import { roomIdSchema } from '@bia/protocol'
import { z } from 'zod'

/**
 * `?measure=1` liga a coleta de deriva entre duas máquinas. Opcional pra
 * que um Link possa omitir.
 *
 * O TanStack passa os valores da query pelo JSON antes de validar, então
 * `measure=1` chega como número e `measure=true` como booleano. Daí a união
 * dos três tipos. A coerção é explícita porque `Boolean('0')` é verdadeiro e
 * `?measure=0` precisa desligar.
 */
const measureFlag = z
  .union([z.boolean(), z.string(), z.number()])
  .optional()
  .transform((value) => value === true || value === 1 || value === '1' || value === 'true')
  .catch(false)

/** Como chamar este aparelho no relatório. */
const labelFlag = z.string().max(80).optional().catch(undefined)

/** A sala vem na query string. Sem sala na URL, cai numa de teste. */
export const roomSearch = z.object({
  room: roomIdSchema.catch('sala-teste'),
  measure: measureFlag,
  label: labelFlag,
})

/**
 * O mesmo, com a sala de verdade opcional.
 *
 * `/portal` sem sala é a tela do paciente fora da sessão, então aqui a
 * ausência não vira `sala-teste`. Sala inválida continua caindo na de teste,
 * que é o comportamento que os testes de ponta a ponta assumem.
 */
export const optionalRoomSearch = z.object({
  room: roomIdSchema.optional().catch('sala-teste'),
  measure: measureFlag,
  label: labelFlag,
})

export const measureSearch = z.object({ room: roomIdSchema.catch('sala-teste') })
